<template>
<ItpPage
  no-primary-button
  :closeButtonText="'Close'|gettext"
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="ContractService"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    stretch
    no-padding
    :col="b_5962862420439144_col"
    full-height
    v-if="loaded"
  >
    <b-tabs
      nav-class="material px-3"
      contentClass="flex-shrink-1 overflow-hidden"
      class="h-100 d-flex flex-column tabs-material overflow-hidden"
    >
      <b-tab
        :title="'General'|pgettext('ContractService')"
        class="container-fluid h-100 pt-4 px-5 overflow-auto"
      >
        <ItpForm
          :id="formId"
          name="contract"
          class="row"
          ref="mainForm"
          @submit="evh_7789867021953041_submit($event, {})"
        >
          <ItpCol>
            <FieldsetContractService
              :item="item"
              :readonly="isReadonly"
              :labelAlign="labelAlign"
            >
            </FieldsetContractService>
          </ItpCol>
        </ItpForm>
      </b-tab>
      <b-tab
        :title="'Fees'|pgettext('ContractService')"
        class="container-fluid h-100 pt-4 px-5 overflow-auto"
      >
        <UCContractServiceFeesEditor
          :service="item"
          :readonly="isReadonly"
          :labelAlign="labelAlign"
        >
        </UCContractServiceFeesEditor>
      </b-tab>
    </b-tabs>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :text="'Save'|pgettext('Button')"
      type="submit"
      :form="formId"
      variant="primary"
      icon="fa-save"
      :spinning="actions.save.isRunning"
    >
    </ItpButton>
    <ItpButton
      :text="'Close'|gettext"
      variant="default"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class ContractService extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    type: String,
  })
  oid!: string;

  @Watch('oid')
  onOid(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("oid")
  }

  @Prop({
    type: String,
    default: "lg",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  item!: any;

  async $$load_item() {
    return this.$fn.fetch('read_contract_service', { parameters: { id: this.oid } })
  }

  labelAlign!: any;
  billingCategories!: any;

  async $$load_billingCategories() {
    return this.$fn.fetch('get_tags', { parameters: { tag_type: 'billing_category' } })
  }

  messages!: any;
  currencies!: any;

  async $$load_currencies() {
    return this.$fn.fetch('list_currency')
  }

  services!: any;

  async $$load_services() {
    return this.$fn.fetch('suggest_product', {
      parameters: { query: '*', top: 50, skip: 0, product_types: 'service', product_invoice_groups: 'all' }
    }).then(data => _.orderBy(data, [p => p.name.toLowerCase()]))
  }

  invoiceGroups!: any;

  async $$load_invoiceGroups() {
    return this.$fn.fetch('list_product_invoice_group')
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_5962862420439144_col!: any;
  dataMembers = ['formId', 'item', 'labelAlign', 'billingCategories', 'messages', 'currencies', 'services', 'invoiceGroups', 'ux', 'b_7315092382398562_modalBindings', 'b_5962862420439144_col'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        formId: null,
        item: null,
        labelAlign: "right",
        billingCategories: null,
        messages: {
          addService: {
            title: this.$fn.pgettext("Contract", "Add Service"),
          }
          ,
          editService: {
            title: this.$fn.pgettext("Contract", "Edit Service"),
          }
          ,
          addServiceFee: {
            title: this.$fn.pgettext("Contract", "Add Service Fee"),
          }
          ,
          editServiceFee: {
            title: this.$fn.pgettext("Contract", "Edit Service Fee"),
          }
          ,
        }
        ,
        currencies: null,
        services: null,
        invoiceGroups: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          noPrimaryButton: true,
          closeButtonText: this.$fn.gettext("Close"),
          size: "lg",
        }
        ,
        b_5962862420439144_col: false,
      },
    }
  }

  get isReadonly() {
    if (this.loaded) {

      return this.item && this.item.isReadonly
    }
    return null;
  }

  get document() {
    if (this.loaded) {

      return {
        title: [this.$fn.gettext("ContractService")
          ,
        ]
        ,
        icon: this.$config.contract.icon,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_2800_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_2800, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_7789867021953041_closeModal_2806_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7789867021953041_closeModal_2806, alias=undefined
    return {
      result: {
        ok: true,
        value: $event.data,
      }
      ,
    }
  }

  async act_7789867021953041_crud_2804_getActionArgs($event: actions.ActionEvent): Promise<actions.CRUDActionArgs> {
    // parameterResolver name=act_7789867021953041_crud_2804, alias=save
    return {
      objectType: "contract_service",
      op: "upsert",
      data: this.item,
      options: {
        parameters: {
          contract_id: this.item.contract.id,
        }
        ,
      }
      ,
    }
  }

  async evh_7789867021953041_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7789867021953041_submit.executeFromDOM(this, event, scope);
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_2800: actions.CloseModalAction;
    evh_7315092382398562_close_2799: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_2802: actions.CloseComponentAction;
    evh_2248226175642056_close_2801: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_7789867021953041_closeModal_2806: actions.CloseModalAction;
    evh_7789867021953041_success_2805: actions.EventHandlerImpl;
    act_7789867021953041_crud_2804: actions.CRUDAction;
    evh_7789867021953041_submit_2803: actions.EventHandlerImpl;
    evh_7789867021953041_submit: actions.EventHandlerGroup;
    act_1419464017721962_closeComponent_2808: actions.CloseComponentAction;
    evh_1419464017721962_clickPreventStop_2807: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_2800 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_2800_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_2799 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_2800,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_2799],
      }
    );
    const act_2248226175642056_closeComponent_2802 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_2801 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_2802,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_2801],
      }
    );
    const act_7789867021953041_closeModal_2806 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7789867021953041_closeModal_2806_getActionArgs,
        events: [],
      }
    );
    const evh_7789867021953041_success_2805 = new actions.EventHandlerImpl(
      {
        action: act_7789867021953041_closeModal_2806,
        event: "success",
        displayName: "closeModal",
      }
    );
    const act_7789867021953041_crud_2804 = new actions.CRUDAction(
      {
        actionArgs: this.act_7789867021953041_crud_2804_getActionArgs,
        displayName: "save",
        events: [evh_7789867021953041_success_2805],
      }
    );
    const evh_7789867021953041_submit_2803 = new actions.EventHandlerImpl(
      {
        action: act_7789867021953041_crud_2804,
        event: "submit",
        displayName: "save",
      }
    );
    const evh_7789867021953041_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_7789867021953041_submit_2803],
      }
    );
    const act_1419464017721962_closeComponent_2808 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_2807 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeComponent_2808,
        event: "click.prevent.stop",
        displayName: "closeComponent",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_2807],
      }
    );
    return {
      act_7315092382398562_closeModal_2800,
      evh_7315092382398562_close_2799,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_2802,
      evh_2248226175642056_close_2801,
      evh_2248226175642056_close,
      act_7789867021953041_closeModal_2806,
      evh_7789867021953041_success_2805,
      act_7789867021953041_crud_2804,
      evh_7789867021953041_submit_2803,
      evh_7789867021953041_submit,
      act_1419464017721962_closeComponent_2808,
      evh_1419464017721962_clickPreventStop_2807,
      evh_1419464017721962_clickPreventStop,
      save: act_7789867021953041_crud_2804,
    }
  }
}

Vue.component("ContractService", ContractService);

</script>